import {useState} from 'react'
import Booking from './booking.jsx'
import CheckRoom from './checkRoom.jsx'





function Room(props){

    const [booking, setBooking] = useState(true)
    const [arrival, setArrival] = useState(new Date());
    const [departure, setDeparture] = useState(new Date());
    const onBoock = (arr, dep) => {
        setArrival(arr)
        setDeparture(dep)
        setBooking(false)
    }
    return(
        <>
        {booking ?
        <CheckRoom lang = {props.lang} link = {props.link} description_room = {props.description_room} img = {props.room}
        number = {props.number} onClick = {onBoock}/>
        
        :
        <Booking lang = {props.lang} arrival = {arrival} departure = {departure} number = {props.number}
        Info = {props.Info}/>
        }
        </>
        )

}

export default Room;